/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdministrationRouteRouteImport } from './routes/administration/route'
import { Route as AgentsRouteRouteImport } from './routes/agents/route'
import { Route as IntelligenceRouteRouteImport } from './routes/intelligence/route'
import { Route as MonitoringRouteRouteImport } from './routes/monitoring/route'
import { Route as OperationsRouteRouteImport } from './routes/operations/route'
import { Route as PortfolioRouteRouteImport } from './routes/portfolio/route'
import { Route as ReferenceRouteRouteImport } from './routes/reference/route'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as AdministrationCleanupOverviewRouteImport } from './routes/administration/cleanup-overview'
import { Route as AdministrationDirectoryRouteImport } from './routes/administration/directory'
import { Route as AdministrationFolderOwnershipRouteImport } from './routes/administration/folder-ownership'
import { Route as AdministrationFunctionsRouteImport } from './routes/administration/functions'
import { Route as AdministrationJobsRouteImport } from './routes/administration/jobs'
import { Route as AdministrationUsersRouteImport } from './routes/administration/users'
import { Route as AgentsFleetRouteImport } from './routes/agents/fleet'
import { Route as AgentsHallucinationsRouteImport } from './routes/agents/hallucinations'
import { Route as AgentsPerformanceRouteImport } from './routes/agents/performance'
import { Route as AgentsPromptsRouteImport } from './routes/agents/prompts'
import { Route as AgentsReviewsRouteImport } from './routes/agents/reviews'
import { Route as IntelligenceComplianceRouteImport } from './routes/intelligence/compliance'
import { Route as IntelligenceExpertRouteImport } from './routes/intelligence/expert'
import { Route as IntelligenceGovernanceRouteImport } from './routes/intelligence/governance'
import { Route as MonitoringInceptionRouteImport } from './routes/monitoring/inception'
import { Route as MonitoringIntakeRouteImport } from './routes/monitoring/intake'
import { Route as MonitoringUnpublishedRouteImport } from './routes/monitoring/unpublished'
import { Route as OperationsApprovalsRouteImport } from './routes/operations/approvals'
import { Route as OperationsCalendarRouteImport } from './routes/operations/calendar'
import { Route as OperationsCleanupRouteImport } from './routes/operations/cleanup'
import { Route as OperationsCompanyRouteImport } from './routes/operations/company'
import { Route as OperationsCorpusRouteImport } from './routes/operations/corpus'
import { Route as OperationsDependenciesRouteImport } from './routes/operations/dependencies'
import { Route as OperationsDiligenceRouteImport } from './routes/operations/diligence'
import { Route as OperationsDropinRouteImport } from './routes/operations/dropin'
import { Route as OperationsIntakeRouteImport } from './routes/operations/intake'
import { Route as OperationsMyFilesRouteImport } from './routes/operations/my-files'
import { Route as OperationsSurveillanceRouteImport } from './routes/operations/surveillance'
import { Route as PortfolioCockpitRouteImport } from './routes/portfolio/cockpit'
import { Route as PortfolioDecisionsRouteImport } from './routes/portfolio/decisions'
import { Route as PortfolioFinancialRouteImport } from './routes/portfolio/financial'
import { Route as ReferenceTruthCardsRouteImport } from './routes/reference/truth-cards'
import { Route as PortfolioDecisionDecisionIdRouteImport } from './routes/portfolio/decision.$decisionId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministrationRouteRoute = AdministrationRouteRouteImport.update({
  id: '/administration',
  path: '/administration',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsRouteRoute = AgentsRouteRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => rootRouteImport,
} as any)
const IntelligenceRouteRoute = IntelligenceRouteRouteImport.update({
  id: '/intelligence',
  path: '/intelligence',
  getParentRoute: () => rootRouteImport,
} as any)
const MonitoringRouteRoute = MonitoringRouteRouteImport.update({
  id: '/monitoring',
  path: '/monitoring',
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsRouteRoute = OperationsRouteRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioRouteRoute = PortfolioRouteRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferenceRouteRoute = ReferenceRouteRouteImport.update({
  id: '/reference',
  path: '/reference',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministrationCleanupOverviewRoute =
  AdministrationCleanupOverviewRouteImport.update({
    id: '/cleanup-overview',
    path: '/cleanup-overview',
    getParentRoute: () => AdministrationRouteRoute,
  } as any)
const AdministrationDirectoryRoute = AdministrationDirectoryRouteImport.update({
  id: '/directory',
  path: '/directory',
  getParentRoute: () => AdministrationRouteRoute,
} as any)
const AdministrationFolderOwnershipRoute =
  AdministrationFolderOwnershipRouteImport.update({
    id: '/folder-ownership',
    path: '/folder-ownership',
    getParentRoute: () => AdministrationRouteRoute,
  } as any)
const AdministrationFunctionsRoute = AdministrationFunctionsRouteImport.update({
  id: '/functions',
  path: '/functions',
  getParentRoute: () => AdministrationRouteRoute,
} as any)
const AdministrationJobsRoute = AdministrationJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AdministrationRouteRoute,
} as any)
const AdministrationUsersRoute = AdministrationUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdministrationRouteRoute,
} as any)
const AgentsFleetRoute = AgentsFleetRouteImport.update({
  id: '/fleet',
  path: '/fleet',
  getParentRoute: () => AgentsRouteRoute,
} as any)
const AgentsHallucinationsRoute = AgentsHallucinationsRouteImport.update({
  id: '/hallucinations',
  path: '/hallucinations',
  getParentRoute: () => AgentsRouteRoute,
} as any)
const AgentsPerformanceRoute = AgentsPerformanceRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => AgentsRouteRoute,
} as any)
const AgentsPromptsRoute = AgentsPromptsRouteImport.update({
  id: '/prompts',
  path: '/prompts',
  getParentRoute: () => AgentsRouteRoute,
} as any)
const AgentsReviewsRoute = AgentsReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => AgentsRouteRoute,
} as any)
const IntelligenceComplianceRoute = IntelligenceComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => IntelligenceRouteRoute,
} as any)
const IntelligenceExpertRoute = IntelligenceExpertRouteImport.update({
  id: '/expert',
  path: '/expert',
  getParentRoute: () => IntelligenceRouteRoute,
} as any)
const IntelligenceGovernanceRoute = IntelligenceGovernanceRouteImport.update({
  id: '/governance',
  path: '/governance',
  getParentRoute: () => IntelligenceRouteRoute,
} as any)
const MonitoringInceptionRoute = MonitoringInceptionRouteImport.update({
  id: '/inception',
  path: '/inception',
  getParentRoute: () => MonitoringRouteRoute,
} as any)
const MonitoringIntakeRoute = MonitoringIntakeRouteImport.update({
  id: '/intake',
  path: '/intake',
  getParentRoute: () => MonitoringRouteRoute,
} as any)
const MonitoringUnpublishedRoute = MonitoringUnpublishedRouteImport.update({
  id: '/unpublished',
  path: '/unpublished',
  getParentRoute: () => MonitoringRouteRoute,
} as any)
const OperationsApprovalsRoute = OperationsApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const OperationsCalendarRoute = OperationsCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const OperationsCleanupRoute = OperationsCleanupRouteImport.update({
  id: '/cleanup',
  path: '/cleanup',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const OperationsCompanyRoute = OperationsCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const OperationsCorpusRoute = OperationsCorpusRouteImport.update({
  id: '/corpus',
  path: '/corpus',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const OperationsDependenciesRoute = OperationsDependenciesRouteImport.update({
  id: '/dependencies',
  path: '/dependencies',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const OperationsDiligenceRoute = OperationsDiligenceRouteImport.update({
  id: '/diligence',
  path: '/diligence',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const OperationsDropinRoute = OperationsDropinRouteImport.update({
  id: '/dropin',
  path: '/dropin',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const OperationsIntakeRoute = OperationsIntakeRouteImport.update({
  id: '/intake',
  path: '/intake',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const OperationsMyFilesRoute = OperationsMyFilesRouteImport.update({
  id: '/my-files',
  path: '/my-files',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const OperationsSurveillanceRoute = OperationsSurveillanceRouteImport.update({
  id: '/surveillance',
  path: '/surveillance',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const PortfolioCockpitRoute = PortfolioCockpitRouteImport.update({
  id: '/cockpit',
  path: '/cockpit',
  getParentRoute: () => PortfolioRouteRoute,
} as any)
const PortfolioDecisionsRoute = PortfolioDecisionsRouteImport.update({
  id: '/decisions',
  path: '/decisions',
  getParentRoute: () => PortfolioRouteRoute,
} as any)
const PortfolioFinancialRoute = PortfolioFinancialRouteImport.update({
  id: '/financial',
  path: '/financial',
  getParentRoute: () => PortfolioRouteRoute,
} as any)
const ReferenceTruthCardsRoute = ReferenceTruthCardsRouteImport.update({
  id: '/truth-cards',
  path: '/truth-cards',
  getParentRoute: () => ReferenceRouteRoute,
} as any)
const PortfolioDecisionDecisionIdRoute =
  PortfolioDecisionDecisionIdRouteImport.update({
    id: '/decision/$decisionId',
    path: '/decision/$decisionId',
    getParentRoute: () => PortfolioRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/administration': typeof AdministrationRouteRouteWithChildren
  '/agents': typeof AgentsRouteRouteWithChildren
  '/intelligence': typeof IntelligenceRouteRouteWithChildren
  '/monitoring': typeof MonitoringRouteRouteWithChildren
  '/operations': typeof OperationsRouteRouteWithChildren
  '/portfolio': typeof PortfolioRouteRouteWithChildren
  '/reference': typeof ReferenceRouteRouteWithChildren
  '/settings': typeof SettingsRoute
  '/administration/cleanup-overview': typeof AdministrationCleanupOverviewRoute
  '/administration/directory': typeof AdministrationDirectoryRoute
  '/administration/folder-ownership': typeof AdministrationFolderOwnershipRoute
  '/administration/functions': typeof AdministrationFunctionsRoute
  '/administration/jobs': typeof AdministrationJobsRoute
  '/administration/users': typeof AdministrationUsersRoute
  '/agents/fleet': typeof AgentsFleetRoute
  '/agents/hallucinations': typeof AgentsHallucinationsRoute
  '/agents/performance': typeof AgentsPerformanceRoute
  '/agents/prompts': typeof AgentsPromptsRoute
  '/agents/reviews': typeof AgentsReviewsRoute
  '/intelligence/compliance': typeof IntelligenceComplianceRoute
  '/intelligence/expert': typeof IntelligenceExpertRoute
  '/intelligence/governance': typeof IntelligenceGovernanceRoute
  '/monitoring/inception': typeof MonitoringInceptionRoute
  '/monitoring/intake': typeof MonitoringIntakeRoute
  '/monitoring/unpublished': typeof MonitoringUnpublishedRoute
  '/operations/approvals': typeof OperationsApprovalsRoute
  '/operations/calendar': typeof OperationsCalendarRoute
  '/operations/cleanup': typeof OperationsCleanupRoute
  '/operations/company': typeof OperationsCompanyRoute
  '/operations/corpus': typeof OperationsCorpusRoute
  '/operations/dependencies': typeof OperationsDependenciesRoute
  '/operations/diligence': typeof OperationsDiligenceRoute
  '/operations/dropin': typeof OperationsDropinRoute
  '/operations/intake': typeof OperationsIntakeRoute
  '/operations/my-files': typeof OperationsMyFilesRoute
  '/operations/surveillance': typeof OperationsSurveillanceRoute
  '/portfolio/cockpit': typeof PortfolioCockpitRoute
  '/portfolio/decisions': typeof PortfolioDecisionsRoute
  '/portfolio/financial': typeof PortfolioFinancialRoute
  '/reference/truth-cards': typeof ReferenceTruthCardsRoute
  '/portfolio/decision/$decisionId': typeof PortfolioDecisionDecisionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/administration': typeof AdministrationRouteRouteWithChildren
  '/agents': typeof AgentsRouteRouteWithChildren
  '/intelligence': typeof IntelligenceRouteRouteWithChildren
  '/monitoring': typeof MonitoringRouteRouteWithChildren
  '/operations': typeof OperationsRouteRouteWithChildren
  '/portfolio': typeof PortfolioRouteRouteWithChildren
  '/reference': typeof ReferenceRouteRouteWithChildren
  '/settings': typeof SettingsRoute
  '/administration/cleanup-overview': typeof AdministrationCleanupOverviewRoute
  '/administration/directory': typeof AdministrationDirectoryRoute
  '/administration/folder-ownership': typeof AdministrationFolderOwnershipRoute
  '/administration/functions': typeof AdministrationFunctionsRoute
  '/administration/jobs': typeof AdministrationJobsRoute
  '/administration/users': typeof AdministrationUsersRoute
  '/agents/fleet': typeof AgentsFleetRoute
  '/agents/hallucinations': typeof AgentsHallucinationsRoute
  '/agents/performance': typeof AgentsPerformanceRoute
  '/agents/prompts': typeof AgentsPromptsRoute
  '/agents/reviews': typeof AgentsReviewsRoute
  '/intelligence/compliance': typeof IntelligenceComplianceRoute
  '/intelligence/expert': typeof IntelligenceExpertRoute
  '/intelligence/governance': typeof IntelligenceGovernanceRoute
  '/monitoring/inception': typeof MonitoringInceptionRoute
  '/monitoring/intake': typeof MonitoringIntakeRoute
  '/monitoring/unpublished': typeof MonitoringUnpublishedRoute
  '/operations/approvals': typeof OperationsApprovalsRoute
  '/operations/calendar': typeof OperationsCalendarRoute
  '/operations/cleanup': typeof OperationsCleanupRoute
  '/operations/company': typeof OperationsCompanyRoute
  '/operations/corpus': typeof OperationsCorpusRoute
  '/operations/dependencies': typeof OperationsDependenciesRoute
  '/operations/diligence': typeof OperationsDiligenceRoute
  '/operations/dropin': typeof OperationsDropinRoute
  '/operations/intake': typeof OperationsIntakeRoute
  '/operations/my-files': typeof OperationsMyFilesRoute
  '/operations/surveillance': typeof OperationsSurveillanceRoute
  '/portfolio/cockpit': typeof PortfolioCockpitRoute
  '/portfolio/decisions': typeof PortfolioDecisionsRoute
  '/portfolio/financial': typeof PortfolioFinancialRoute
  '/reference/truth-cards': typeof ReferenceTruthCardsRoute
  '/portfolio/decision/$decisionId': typeof PortfolioDecisionDecisionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/administration': typeof AdministrationRouteRouteWithChildren
  '/agents': typeof AgentsRouteRouteWithChildren
  '/intelligence': typeof IntelligenceRouteRouteWithChildren
  '/monitoring': typeof MonitoringRouteRouteWithChildren
  '/operations': typeof OperationsRouteRouteWithChildren
  '/portfolio': typeof PortfolioRouteRouteWithChildren
  '/reference': typeof ReferenceRouteRouteWithChildren
  '/settings': typeof SettingsRoute
  '/administration/cleanup-overview': typeof AdministrationCleanupOverviewRoute
  '/administration/directory': typeof AdministrationDirectoryRoute
  '/administration/folder-ownership': typeof AdministrationFolderOwnershipRoute
  '/administration/functions': typeof AdministrationFunctionsRoute
  '/administration/jobs': typeof AdministrationJobsRoute
  '/administration/users': typeof AdministrationUsersRoute
  '/agents/fleet': typeof AgentsFleetRoute
  '/agents/hallucinations': typeof AgentsHallucinationsRoute
  '/agents/performance': typeof AgentsPerformanceRoute
  '/agents/prompts': typeof AgentsPromptsRoute
  '/agents/reviews': typeof AgentsReviewsRoute
  '/intelligence/compliance': typeof IntelligenceComplianceRoute
  '/intelligence/expert': typeof IntelligenceExpertRoute
  '/intelligence/governance': typeof IntelligenceGovernanceRoute
  '/monitoring/inception': typeof MonitoringInceptionRoute
  '/monitoring/intake': typeof MonitoringIntakeRoute
  '/monitoring/unpublished': typeof MonitoringUnpublishedRoute
  '/operations/approvals': typeof OperationsApprovalsRoute
  '/operations/calendar': typeof OperationsCalendarRoute
  '/operations/cleanup': typeof OperationsCleanupRoute
  '/operations/company': typeof OperationsCompanyRoute
  '/operations/corpus': typeof OperationsCorpusRoute
  '/operations/dependencies': typeof OperationsDependenciesRoute
  '/operations/diligence': typeof OperationsDiligenceRoute
  '/operations/dropin': typeof OperationsDropinRoute
  '/operations/intake': typeof OperationsIntakeRoute
  '/operations/my-files': typeof OperationsMyFilesRoute
  '/operations/surveillance': typeof OperationsSurveillanceRoute
  '/portfolio/cockpit': typeof PortfolioCockpitRoute
  '/portfolio/decisions': typeof PortfolioDecisionsRoute
  '/portfolio/financial': typeof PortfolioFinancialRoute
  '/reference/truth-cards': typeof ReferenceTruthCardsRoute
  '/portfolio/decision/$decisionId': typeof PortfolioDecisionDecisionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/administration'
    | '/agents'
    | '/intelligence'
    | '/monitoring'
    | '/operations'
    | '/portfolio'
    | '/reference'
    | '/settings'
    | '/administration/cleanup-overview'
    | '/administration/directory'
    | '/administration/folder-ownership'
    | '/administration/functions'
    | '/administration/jobs'
    | '/administration/users'
    | '/agents/fleet'
    | '/agents/hallucinations'
    | '/agents/performance'
    | '/agents/prompts'
    | '/agents/reviews'
    | '/intelligence/compliance'
    | '/intelligence/expert'
    | '/intelligence/governance'
    | '/monitoring/inception'
    | '/monitoring/intake'
    | '/monitoring/unpublished'
    | '/operations/approvals'
    | '/operations/calendar'
    | '/operations/cleanup'
    | '/operations/company'
    | '/operations/corpus'
    | '/operations/dependencies'
    | '/operations/diligence'
    | '/operations/dropin'
    | '/operations/intake'
    | '/operations/my-files'
    | '/operations/surveillance'
    | '/portfolio/cockpit'
    | '/portfolio/decisions'
    | '/portfolio/financial'
    | '/reference/truth-cards'
    | '/portfolio/decision/$decisionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/administration'
    | '/agents'
    | '/intelligence'
    | '/monitoring'
    | '/operations'
    | '/portfolio'
    | '/reference'
    | '/settings'
    | '/administration/cleanup-overview'
    | '/administration/directory'
    | '/administration/folder-ownership'
    | '/administration/functions'
    | '/administration/jobs'
    | '/administration/users'
    | '/agents/fleet'
    | '/agents/hallucinations'
    | '/agents/performance'
    | '/agents/prompts'
    | '/agents/reviews'
    | '/intelligence/compliance'
    | '/intelligence/expert'
    | '/intelligence/governance'
    | '/monitoring/inception'
    | '/monitoring/intake'
    | '/monitoring/unpublished'
    | '/operations/approvals'
    | '/operations/calendar'
    | '/operations/cleanup'
    | '/operations/company'
    | '/operations/corpus'
    | '/operations/dependencies'
    | '/operations/diligence'
    | '/operations/dropin'
    | '/operations/intake'
    | '/operations/my-files'
    | '/operations/surveillance'
    | '/portfolio/cockpit'
    | '/portfolio/decisions'
    | '/portfolio/financial'
    | '/reference/truth-cards'
    | '/portfolio/decision/$decisionId'
  id:
    | '__root__'
    | '/'
    | '/administration'
    | '/agents'
    | '/intelligence'
    | '/monitoring'
    | '/operations'
    | '/portfolio'
    | '/reference'
    | '/settings'
    | '/administration/cleanup-overview'
    | '/administration/directory'
    | '/administration/folder-ownership'
    | '/administration/functions'
    | '/administration/jobs'
    | '/administration/users'
    | '/agents/fleet'
    | '/agents/hallucinations'
    | '/agents/performance'
    | '/agents/prompts'
    | '/agents/reviews'
    | '/intelligence/compliance'
    | '/intelligence/expert'
    | '/intelligence/governance'
    | '/monitoring/inception'
    | '/monitoring/intake'
    | '/monitoring/unpublished'
    | '/operations/approvals'
    | '/operations/calendar'
    | '/operations/cleanup'
    | '/operations/company'
    | '/operations/corpus'
    | '/operations/dependencies'
    | '/operations/diligence'
    | '/operations/dropin'
    | '/operations/intake'
    | '/operations/my-files'
    | '/operations/surveillance'
    | '/portfolio/cockpit'
    | '/portfolio/decisions'
    | '/portfolio/financial'
    | '/reference/truth-cards'
    | '/portfolio/decision/$decisionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdministrationRouteRoute: typeof AdministrationRouteRouteWithChildren
  AgentsRouteRoute: typeof AgentsRouteRouteWithChildren
  IntelligenceRouteRoute: typeof IntelligenceRouteRouteWithChildren
  MonitoringRouteRoute: typeof MonitoringRouteRouteWithChildren
  OperationsRouteRoute: typeof OperationsRouteRouteWithChildren
  PortfolioRouteRoute: typeof PortfolioRouteRouteWithChildren
  ReferenceRouteRoute: typeof ReferenceRouteRouteWithChildren
  SettingsRoute: typeof SettingsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration': {
      id: '/administration'
      path: '/administration'
      fullPath: '/administration'
      preLoaderRoute: typeof AdministrationRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents': {
      id: '/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AgentsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/intelligence': {
      id: '/intelligence'
      path: '/intelligence'
      fullPath: '/intelligence'
      preLoaderRoute: typeof IntelligenceRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/monitoring': {
      id: '/monitoring'
      path: '/monitoring'
      fullPath: '/monitoring'
      preLoaderRoute: typeof MonitoringRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operations': {
      id: '/operations'
      path: '/operations'
      fullPath: '/operations'
      preLoaderRoute: typeof OperationsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio': {
      id: '/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof PortfolioRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reference': {
      id: '/reference'
      path: '/reference'
      fullPath: '/reference'
      preLoaderRoute: typeof ReferenceRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/cleanup-overview': {
      id: '/administration/cleanup-overview'
      path: '/cleanup-overview'
      fullPath: '/administration/cleanup-overview'
      preLoaderRoute: typeof AdministrationCleanupOverviewRouteImport
      parentRoute: typeof AdministrationRouteRoute
    }
    '/administration/directory': {
      id: '/administration/directory'
      path: '/directory'
      fullPath: '/administration/directory'
      preLoaderRoute: typeof AdministrationDirectoryRouteImport
      parentRoute: typeof AdministrationRouteRoute
    }
    '/administration/folder-ownership': {
      id: '/administration/folder-ownership'
      path: '/folder-ownership'
      fullPath: '/administration/folder-ownership'
      preLoaderRoute: typeof AdministrationFolderOwnershipRouteImport
      parentRoute: typeof AdministrationRouteRoute
    }
    '/administration/functions': {
      id: '/administration/functions'
      path: '/functions'
      fullPath: '/administration/functions'
      preLoaderRoute: typeof AdministrationFunctionsRouteImport
      parentRoute: typeof AdministrationRouteRoute
    }
    '/administration/jobs': {
      id: '/administration/jobs'
      path: '/jobs'
      fullPath: '/administration/jobs'
      preLoaderRoute: typeof AdministrationJobsRouteImport
      parentRoute: typeof AdministrationRouteRoute
    }
    '/administration/users': {
      id: '/administration/users'
      path: '/users'
      fullPath: '/administration/users'
      preLoaderRoute: typeof AdministrationUsersRouteImport
      parentRoute: typeof AdministrationRouteRoute
    }
    '/agents/fleet': {
      id: '/agents/fleet'
      path: '/fleet'
      fullPath: '/agents/fleet'
      preLoaderRoute: typeof AgentsFleetRouteImport
      parentRoute: typeof AgentsRouteRoute
    }
    '/agents/hallucinations': {
      id: '/agents/hallucinations'
      path: '/hallucinations'
      fullPath: '/agents/hallucinations'
      preLoaderRoute: typeof AgentsHallucinationsRouteImport
      parentRoute: typeof AgentsRouteRoute
    }
    '/agents/performance': {
      id: '/agents/performance'
      path: '/performance'
      fullPath: '/agents/performance'
      preLoaderRoute: typeof AgentsPerformanceRouteImport
      parentRoute: typeof AgentsRouteRoute
    }
    '/agents/prompts': {
      id: '/agents/prompts'
      path: '/prompts'
      fullPath: '/agents/prompts'
      preLoaderRoute: typeof AgentsPromptsRouteImport
      parentRoute: typeof AgentsRouteRoute
    }
    '/agents/reviews': {
      id: '/agents/reviews'
      path: '/reviews'
      fullPath: '/agents/reviews'
      preLoaderRoute: typeof AgentsReviewsRouteImport
      parentRoute: typeof AgentsRouteRoute
    }
    '/intelligence/compliance': {
      id: '/intelligence/compliance'
      path: '/compliance'
      fullPath: '/intelligence/compliance'
      preLoaderRoute: typeof IntelligenceComplianceRouteImport
      parentRoute: typeof IntelligenceRouteRoute
    }
    '/intelligence/expert': {
      id: '/intelligence/expert'
      path: '/expert'
      fullPath: '/intelligence/expert'
      preLoaderRoute: typeof IntelligenceExpertRouteImport
      parentRoute: typeof IntelligenceRouteRoute
    }
    '/intelligence/governance': {
      id: '/intelligence/governance'
      path: '/governance'
      fullPath: '/intelligence/governance'
      preLoaderRoute: typeof IntelligenceGovernanceRouteImport
      parentRoute: typeof IntelligenceRouteRoute
    }
    '/monitoring/inception': {
      id: '/monitoring/inception'
      path: '/inception'
      fullPath: '/monitoring/inception'
      preLoaderRoute: typeof MonitoringInceptionRouteImport
      parentRoute: typeof MonitoringRouteRoute
    }
    '/monitoring/intake': {
      id: '/monitoring/intake'
      path: '/intake'
      fullPath: '/monitoring/intake'
      preLoaderRoute: typeof MonitoringIntakeRouteImport
      parentRoute: typeof MonitoringRouteRoute
    }
    '/monitoring/unpublished': {
      id: '/monitoring/unpublished'
      path: '/unpublished'
      fullPath: '/monitoring/unpublished'
      preLoaderRoute: typeof MonitoringUnpublishedRouteImport
      parentRoute: typeof MonitoringRouteRoute
    }
    '/operations/approvals': {
      id: '/operations/approvals'
      path: '/approvals'
      fullPath: '/operations/approvals'
      preLoaderRoute: typeof OperationsApprovalsRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/calendar': {
      id: '/operations/calendar'
      path: '/calendar'
      fullPath: '/operations/calendar'
      preLoaderRoute: typeof OperationsCalendarRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/cleanup': {
      id: '/operations/cleanup'
      path: '/cleanup'
      fullPath: '/operations/cleanup'
      preLoaderRoute: typeof OperationsCleanupRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/company': {
      id: '/operations/company'
      path: '/company'
      fullPath: '/operations/company'
      preLoaderRoute: typeof OperationsCompanyRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/corpus': {
      id: '/operations/corpus'
      path: '/corpus'
      fullPath: '/operations/corpus'
      preLoaderRoute: typeof OperationsCorpusRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/dependencies': {
      id: '/operations/dependencies'
      path: '/dependencies'
      fullPath: '/operations/dependencies'
      preLoaderRoute: typeof OperationsDependenciesRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/diligence': {
      id: '/operations/diligence'
      path: '/diligence'
      fullPath: '/operations/diligence'
      preLoaderRoute: typeof OperationsDiligenceRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/dropin': {
      id: '/operations/dropin'
      path: '/dropin'
      fullPath: '/operations/dropin'
      preLoaderRoute: typeof OperationsDropinRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/intake': {
      id: '/operations/intake'
      path: '/intake'
      fullPath: '/operations/intake'
      preLoaderRoute: typeof OperationsIntakeRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/my-files': {
      id: '/operations/my-files'
      path: '/my-files'
      fullPath: '/operations/my-files'
      preLoaderRoute: typeof OperationsMyFilesRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/surveillance': {
      id: '/operations/surveillance'
      path: '/surveillance'
      fullPath: '/operations/surveillance'
      preLoaderRoute: typeof OperationsSurveillanceRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/portfolio/cockpit': {
      id: '/portfolio/cockpit'
      path: '/cockpit'
      fullPath: '/portfolio/cockpit'
      preLoaderRoute: typeof PortfolioCockpitRouteImport
      parentRoute: typeof PortfolioRouteRoute
    }
    '/portfolio/decisions': {
      id: '/portfolio/decisions'
      path: '/decisions'
      fullPath: '/portfolio/decisions'
      preLoaderRoute: typeof PortfolioDecisionsRouteImport
      parentRoute: typeof PortfolioRouteRoute
    }
    '/portfolio/financial': {
      id: '/portfolio/financial'
      path: '/financial'
      fullPath: '/portfolio/financial'
      preLoaderRoute: typeof PortfolioFinancialRouteImport
      parentRoute: typeof PortfolioRouteRoute
    }
    '/reference/truth-cards': {
      id: '/reference/truth-cards'
      path: '/truth-cards'
      fullPath: '/reference/truth-cards'
      preLoaderRoute: typeof ReferenceTruthCardsRouteImport
      parentRoute: typeof ReferenceRouteRoute
    }
    '/portfolio/decision/$decisionId': {
      id: '/portfolio/decision/$decisionId'
      path: '/decision/$decisionId'
      fullPath: '/portfolio/decision/$decisionId'
      preLoaderRoute: typeof PortfolioDecisionDecisionIdRouteImport
      parentRoute: typeof PortfolioRouteRoute
    }
  }
}

interface AdministrationRouteRouteChildren {
  AdministrationCleanupOverviewRoute: typeof AdministrationCleanupOverviewRoute
  AdministrationDirectoryRoute: typeof AdministrationDirectoryRoute
  AdministrationFolderOwnershipRoute: typeof AdministrationFolderOwnershipRoute
  AdministrationFunctionsRoute: typeof AdministrationFunctionsRoute
  AdministrationJobsRoute: typeof AdministrationJobsRoute
  AdministrationUsersRoute: typeof AdministrationUsersRoute
}

const AdministrationRouteRouteChildren: AdministrationRouteRouteChildren = {
  AdministrationCleanupOverviewRoute: AdministrationCleanupOverviewRoute,
  AdministrationDirectoryRoute: AdministrationDirectoryRoute,
  AdministrationFolderOwnershipRoute: AdministrationFolderOwnershipRoute,
  AdministrationFunctionsRoute: AdministrationFunctionsRoute,
  AdministrationJobsRoute: AdministrationJobsRoute,
  AdministrationUsersRoute: AdministrationUsersRoute,
}

const AdministrationRouteRouteWithChildren =
  AdministrationRouteRoute._addFileChildren(AdministrationRouteRouteChildren)

interface AgentsRouteRouteChildren {
  AgentsFleetRoute: typeof AgentsFleetRoute
  AgentsHallucinationsRoute: typeof AgentsHallucinationsRoute
  AgentsPerformanceRoute: typeof AgentsPerformanceRoute
  AgentsPromptsRoute: typeof AgentsPromptsRoute
  AgentsReviewsRoute: typeof AgentsReviewsRoute
}

const AgentsRouteRouteChildren: AgentsRouteRouteChildren = {
  AgentsFleetRoute: AgentsFleetRoute,
  AgentsHallucinationsRoute: AgentsHallucinationsRoute,
  AgentsPerformanceRoute: AgentsPerformanceRoute,
  AgentsPromptsRoute: AgentsPromptsRoute,
  AgentsReviewsRoute: AgentsReviewsRoute,
}

const AgentsRouteRouteWithChildren = AgentsRouteRoute._addFileChildren(
  AgentsRouteRouteChildren,
)

interface IntelligenceRouteRouteChildren {
  IntelligenceComplianceRoute: typeof IntelligenceComplianceRoute
  IntelligenceExpertRoute: typeof IntelligenceExpertRoute
  IntelligenceGovernanceRoute: typeof IntelligenceGovernanceRoute
}

const IntelligenceRouteRouteChildren: IntelligenceRouteRouteChildren = {
  IntelligenceComplianceRoute: IntelligenceComplianceRoute,
  IntelligenceExpertRoute: IntelligenceExpertRoute,
  IntelligenceGovernanceRoute: IntelligenceGovernanceRoute,
}

const IntelligenceRouteRouteWithChildren =
  IntelligenceRouteRoute._addFileChildren(IntelligenceRouteRouteChildren)

interface MonitoringRouteRouteChildren {
  MonitoringInceptionRoute: typeof MonitoringInceptionRoute
  MonitoringIntakeRoute: typeof MonitoringIntakeRoute
  MonitoringUnpublishedRoute: typeof MonitoringUnpublishedRoute
}

const MonitoringRouteRouteChildren: MonitoringRouteRouteChildren = {
  MonitoringInceptionRoute: MonitoringInceptionRoute,
  MonitoringIntakeRoute: MonitoringIntakeRoute,
  MonitoringUnpublishedRoute: MonitoringUnpublishedRoute,
}

const MonitoringRouteRouteWithChildren = MonitoringRouteRoute._addFileChildren(
  MonitoringRouteRouteChildren,
)

interface OperationsRouteRouteChildren {
  OperationsApprovalsRoute: typeof OperationsApprovalsRoute
  OperationsCalendarRoute: typeof OperationsCalendarRoute
  OperationsCleanupRoute: typeof OperationsCleanupRoute
  OperationsCompanyRoute: typeof OperationsCompanyRoute
  OperationsCorpusRoute: typeof OperationsCorpusRoute
  OperationsDependenciesRoute: typeof OperationsDependenciesRoute
  OperationsDiligenceRoute: typeof OperationsDiligenceRoute
  OperationsDropinRoute: typeof OperationsDropinRoute
  OperationsIntakeRoute: typeof OperationsIntakeRoute
  OperationsMyFilesRoute: typeof OperationsMyFilesRoute
  OperationsSurveillanceRoute: typeof OperationsSurveillanceRoute
}

const OperationsRouteRouteChildren: OperationsRouteRouteChildren = {
  OperationsApprovalsRoute: OperationsApprovalsRoute,
  OperationsCalendarRoute: OperationsCalendarRoute,
  OperationsCleanupRoute: OperationsCleanupRoute,
  OperationsCompanyRoute: OperationsCompanyRoute,
  OperationsCorpusRoute: OperationsCorpusRoute,
  OperationsDependenciesRoute: OperationsDependenciesRoute,
  OperationsDiligenceRoute: OperationsDiligenceRoute,
  OperationsDropinRoute: OperationsDropinRoute,
  OperationsIntakeRoute: OperationsIntakeRoute,
  OperationsMyFilesRoute: OperationsMyFilesRoute,
  OperationsSurveillanceRoute: OperationsSurveillanceRoute,
}

const OperationsRouteRouteWithChildren = OperationsRouteRoute._addFileChildren(
  OperationsRouteRouteChildren,
)

interface PortfolioRouteRouteChildren {
  PortfolioCockpitRoute: typeof PortfolioCockpitRoute
  PortfolioDecisionsRoute: typeof PortfolioDecisionsRoute
  PortfolioFinancialRoute: typeof PortfolioFinancialRoute
  PortfolioDecisionDecisionIdRoute: typeof PortfolioDecisionDecisionIdRoute
}

const PortfolioRouteRouteChildren: PortfolioRouteRouteChildren = {
  PortfolioCockpitRoute: PortfolioCockpitRoute,
  PortfolioDecisionsRoute: PortfolioDecisionsRoute,
  PortfolioFinancialRoute: PortfolioFinancialRoute,
  PortfolioDecisionDecisionIdRoute: PortfolioDecisionDecisionIdRoute,
}

const PortfolioRouteRouteWithChildren = PortfolioRouteRoute._addFileChildren(
  PortfolioRouteRouteChildren,
)

interface ReferenceRouteRouteChildren {
  ReferenceTruthCardsRoute: typeof ReferenceTruthCardsRoute
}

const ReferenceRouteRouteChildren: ReferenceRouteRouteChildren = {
  ReferenceTruthCardsRoute: ReferenceTruthCardsRoute,
}

const ReferenceRouteRouteWithChildren = ReferenceRouteRoute._addFileChildren(
  ReferenceRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdministrationRouteRoute: AdministrationRouteRouteWithChildren,
  AgentsRouteRoute: AgentsRouteRouteWithChildren,
  IntelligenceRouteRoute: IntelligenceRouteRouteWithChildren,
  MonitoringRouteRoute: MonitoringRouteRouteWithChildren,
  OperationsRouteRoute: OperationsRouteRouteWithChildren,
  PortfolioRouteRoute: PortfolioRouteRouteWithChildren,
  ReferenceRouteRoute: ReferenceRouteRouteWithChildren,
  SettingsRoute: SettingsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
